"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sdk = require("./QCObjects-SDK");
module.exports = sdk;
